import type { CannedCollectionModuleCard } from '@coursera-web/cds-labs/components/Modules/CannedCollectionModule/CannedCollectionModule';

import config from 'js/app/config';

import _t from 'i18n!nls/front-page';

export default function getPromoUnitProps() {
  const courseraPlusProps: Omit<CannedCollectionModuleCard, 'onClick'> = {
    id: 'coursera-plus-promo-unit',
    eyebrowImage: {
      url: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/2WHjXiZph0ese6wt3ujguH/ae557060d4c9d93388ac80080b3864bb/Brand__2_.png`,
    },
    headline: _t('Unlock access to 10,000+ courses with a subscription'),
    cardBackgroundImage: {
      url: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/6P9DiTmdmcer8Zf7aHk2HJ/99a90ec6e9a6274d07c3f5da3b10e687/474x328-C_.png`,
      width: 600,
      height: 416,
    },
    ctaText: _t('Start 7-day free trial'),
    target: `${config.url.base}courseraplus`,
    backgroundColor: 'blue',
    ctaVariant: 'ghostInvert',
    openInNewTab: false,
  };

  const courseraForBusinessProps: Omit<CannedCollectionModuleCard, 'onClick'> = {
    id: 'coursera-for-business-promo-unit',
    eyebrowImage: {
      url: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/G4qlahDi3SptCFCAcPvCb/8a92841d88cc36036f058a13da2cfcfd/2_Sub_Brand.png`,
    },
    headline: _t('Drive your business forward and empower your teams'),
    cardBackgroundImage: {
      url: `${config.url.imageProxyRoot}https://images.ctfassets.net/00atxywtfxvd/Cb3tIS562yNwOycYVtgEA/c0ae706313c23a9448476155a3dc31f7/474x328.png`,
      width: 600,
      height: 416,
    },
    ctaText: _t('Try Coursera for Business'),
    target: `${config.url.base}business?utm_campaign=website&utm_content=banner-from-B2C-home-for-enterprise&utm_medium=coursera&utm_source=enterprise&utm_term=treatment`,
    backgroundColor: 'dark-blue',
    ctaVariant: 'ghostInvert',
    openInNewTab: false,
  };

  return {
    courseraPlusProps,
    courseraForBusinessProps,
  };
}
